import Vue from 'vue';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
import api from '../request';

import ec_home from '../views/ec_home';
import ec_basic from '../views/ec_basic';
import ec_info from '../views/ec_info';
import ec_projects from '../views/ec_projects';
import ec_medias from '../views/ec_medias';
import ec_lives from '../views/ec_lives';

const routes = [
  {
    path: '/',
  },
  {
    path: '/home',
    name: 'Home',
    component: ec_home,
  },
  {
    path: '/basic',
    name: 'Basic',
    component: ec_basic,
  },
  {
    path: '/info',
    name: 'Info',
    component: ec_info,
  },
  {
    path: '/projects',
    name: 'Projects',
    component: ec_projects,
  },
  {
    path: '/medias',
    name: 'Medias',
    component: ec_medias,
  },
  {
    path: '/lives',
    name: 'Lives',
    component: ec_lives,
  },
]

const router = new VueRouter({
  mode: 'history',
  routes
});
router.beforeEach((to, from, next) => {
  console.log(from, to);
  if (to.path === '/') {
    if (window.location.host === 'ssy-app.com' || window.location.host === 'localhost:8080') {
      return window.location.replace('https://www.ssy-app.com');
    } else {
      return next('/home');
    }
  }
  if (to.path === '/home' || to.path === '/info' || to.path === '/projects' || to.path === '/medias' || to.path === '/lives') {
    let path = window.location.href.replace(window.location.host, '').replace(`${window.location.protocol}//`, '');
    return api.post('/wapi', {
      method: "ssy-app/check", data: { path }
    }).then((res) => {
      const { redirect } = res.data || {};
      if (redirect) window.location.replace(redirect);
      else next();
    }).catch((err) => {
      next();
    });
  }
  next();
});
export default router
